import React from 'react';
import { makeStyles } from '@material-ui/core';
import Logo from './logo.png';
import { useServiceRegistryTranslation } from '../../i18n/ServiceRegistryLanguageProvider';

const useStyles = makeStyles({
  img: {
    height: 30,
    marginLeft: '-6px',
    marginTop: 4,
    width: 'auto',
  },
});

const LogoIcon = () => {
  const { t } = useServiceRegistryTranslation();
  const classes = useStyles();
  return <img className={classes.img} src={Logo} alt={t('signIn.logoAlt')} />
};

export default LogoIcon;
